import { Component, Input } from '@angular/core';

@Component({
  selector: 'fgb-game-nav',
  templateUrl: './game-nav.component.html',
  styleUrls: ['./game-nav.component.scss'],
})
export class GameNavComponent {
  @Input() routeLink: string;
  @Input() isRulesEnabled: boolean = false;
}
